import { Component, OnInit } from "@angular/core";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-mobile-app-download',
    templateUrl: './mobile-app-download.component.html',
    styleUrls: ['./mobile-app-download.component.scss']
  })
  export class MobileAppDownloadComponent implements OnInit {
    deviceInfo:any
      assets_url = environment.assets_url;
      settingsData: any = {}

    constructor(private commonSubscribeService: CommanSubscribeService,
        public router: Router,
    ){
        
    }
    ngOnInit(): void {
      this.settingsData = this.commonSubscribeService.icWebpageSettingsData;

        console.log("$$$$$$$$$$$$$$$",this.deviceInfo)
        let device = this.commonSubscribeService.getMobileOperatingSystem();
        this.deviceInfo = device;
        console.log(this.deviceInfo)
    }
  }